export default __webpack_public_path__ + "static/media/Babay-Adi.db5c96ad.png";